<template lang="html">
  <div class="alert alert-danger">
    {{err}}
  </div>
</template>

<script>
export default {
  props: ['err'],
  name: 'ResponseError'
}
</script>

<style lang="css" scoped>
</style>
